import { render, staticRenderFns } from "./GeneralCulture.vue?vue&type=template&id=2fee31c2&"
import script from "./GeneralCulture.vue?vue&type=script&lang=ts&"
export * from "./GeneralCulture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports